export default {"src":"/_next/static/media/MummyWalk.55185350.svg","height":212,"width":133};